<template>
    <a-form-item v-bind="fiConfig">
        <a-select v-bind="slConfig" v-on="$listeners" @change="handleChange" v-decorator="decorator||[]">
            <a-select-option v-for="d in options" :key="d.value">{{d.text}}</a-select-option>
        </a-select>
    </a-form-item>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['label', 'selectedObj', 'placeholder', 'options', 'decorator', 'selectConfig', 'formItemConfig'],
    beforeMount () {
      this.slConfig = {...this.slConfig, ...this.selectConfig}
      this.fiConfig = {...this.fiConfig, ...this.formItemConfig}
    },
    data () {
      return {
        slConfig: {
          showSearch: Array.isArray(this.options) && this.options.length > 5,
          placeholder: this.placeholder || 'Seleccione una opción',
          defaultActiveFirstOption: true,
          allowClear: true,
          filterOption: this.filterOption
        },
        fiConfig: {
          'label-col': {span: 3},
          'wrapper-col': {span: 21},
          label: this.label,
          'has-feedback': true
        }
      }
    },
    methods: {
      handleChange (value) {
        if (JsUtils.isEmpty(value)) {
          this.$emit('update:selectedObj', {})
          return
        }
        for (let i = 0; i < this.options.length; i++) {
          let option = this.options[i]
          if (option.value === value) {
            this.$emit('update:selectedObj', option)
            return
          }
        }
      },
      filterOption (input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/select.vue